export type ArchiveStatus = "已删改" | "可回溯" | "仅缓存";

export interface ArchiveRecord {
  id: number;
  title: string;
  url: string;
  category: string;
  source: string;
  lastCrawl: string;
  firstSeen: string;
  snapCount: number;
  changePct: number;
  status: ArchiveStatus;
  tags: string[];
  digest: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TestimonialItem {
  role: string;
  name: string;
  text: string;
  tag: string;
}

export const archiveCategories = ["全部", "热点事件", "综艺娱乐", "社会热议", "品牌公关", "行业动态"];

export const archives: ArchiveRecord[] = [
  {
    id: 1,
    title: "某卫视热播综艺选手互动专区主页",
    url: "https://ssnnyw.cn/arch/10423",
    category: "综艺娱乐",
    source: "互动主页",
    lastCrawl: "2026-09-06 21:40",
    firstSeen: "2026-08-12",
    snapCount: 36,
    changePct: 18,
    status: "可回溯",
    tags: ["删改", "已留痕"],
    digest: "该主页近两周经历多次局部删改，早期版本中的节目排期与选手互动详情仍可在存档中完整还原查看。",
  },
  {
    id: 2,
    title: "某品牌联名发布会直播专题页",
    url: "https://ssnnyw.cn/arch/10431",
    category: "品牌公关",
    source: "专题页",
    lastCrawl: "2026-09-06 18:12",
    firstSeen: "2026-08-20",
    snapCount: 22,
    changePct: 42,
    status: "已删改",
    tags: ["大改", "原文留存"],
    digest: "发布会结束后专题页被大幅精简，首发版本的完整口径、产品细节与评论区原文均在缓存快照中被保留。",
  },
  {
    id: 3,
    title: "某热门话题微博热词词条页",
    url: "https://ssnnyw.cn/arch/10388",
    category: "社会热议",
    source: "热词词条",
    lastCrawl: "2026-09-05 23:05",
    firstSeen: "2026-08-08",
    snapCount: 61,
    changePct: 55,
    status: "可回溯",
    tags: ["高频更新", "争议内容"],
    digest: "词条在48小时内被编辑超过二十次，早期争议性叙述与引用的来源页面均被快照捕捉，支持逐版本对比。",
  },
  {
    id: 4,
    title: "某访谈栏目嘉宾问答专稿页",
    url: "https://ssnnyw.cn/arch/10445",
    category: "综艺娱乐",
    source: "专稿页",
    lastCrawl: "2026-09-06 15:30",
    firstSeen: "2026-08-30",
    snapCount: 9,
    changePct: 26,
    status: "仅缓存",
    tags: ["缓存版本", "正文存档"],
    digest: "原专稿已被下线，当前仅可通过缓存版本查看。存档保留了完整问答正文与首发配图说明。",
  },
  {
    id: 5,
    title: "某行业峰会圆桌速记页",
    url: "https://ssnnyw.cn/arch/10412",
    category: "行业动态",
    source: "速记页",
    lastCrawl: "2026-09-04 20:18",
    firstSeen: "2026-07-25",
    snapCount: 14,
    changePct: 9,
    status: "可回溯",
    tags: ["口径修正", "时间线"],
    digest: "峰会速记中个别表述陆续被校正，历史版本完整保留了原始记录，便于核验前后口径变化。",
  },
  {
    id: 6,
    title: "某地区民生事件报道专题页",
    url: "https://ssnnyw.cn/arch/10370",
    category: "社会热议",
    source: "报道专题",
    lastCrawl: "2026-09-05 11:47",
    firstSeen: "2026-07-18",
    snapCount: 48,
    changePct: 63,
    status: "已删改",
    tags: ["多处删改", "进度追踪"],
    digest: "事件发酵期间报道页经历多轮内容调整，早期现场细节、时间线与官方回应的原始版本均可逐条对照。",
  },
  {
    id: 7,
    title: "某明星团队致歉声明原文页",
    url: "https://ssnnyw.cn/arch/10456",
    category: "品牌公关",
    source: "声明页",
    lastCrawl: "2026-09-06 22:03",
    firstSeen: "2026-09-03",
    snapCount: 5,
    changePct: 12,
    status: "仅缓存",
    tags: ["声明原文", "快速下架"],
    digest: "声明发布数小时后即被替换为简版，完整署名与时间戳的原始版本保存在快照库中可随时调阅。",
  },
  {
    id: 8,
    title: "某创作者长文回应页面",
    url: "https://ssnnyw.cn/arch/10460",
    category: "热点事件",
    source: "长文页",
    lastCrawl: "2026-09-06 19:55",
    firstSeen: "2026-09-01",
    snapCount: 11,
    changePct: 21,
    status: "可回溯",
    tags: ["回应全文", "留存"],
    digest: "回应长文已从原地址移除，但按时间点保存的完整正文与评论区互动仍能一键回溯查看。",
  },
  {
    id: 9,
    title: "某综艺赛制规则说明页",
    url: "https://ssnnyw.cn/arch/10408",
    category: "综艺娱乐",
    source: "规则页",
    lastCrawl: "2026-09-03 16:22",
    firstSeen: "2026-06-30",
    snapCount: 27,
    changePct: 15,
    status: "可回溯",
    tags: ["赛制对比", "规则变更"],
    digest: "赛制规则在播出期间多次微调，存档保留每轮更新前版本，方便横向对比淘汰与晋级口径。",
  },
  {
    id: 10,
    title: "某上市公司回应舆情公告页",
    url: "https://ssnnyw.cn/arch/10402",
    category: "行业动态",
    source: "公告页",
    lastCrawl: "2026-09-05 09:38",
    firstSeen: "2026-08-15",
    snapCount: 18,
    changePct: 7,
    status: "可回溯",
    tags: ["公告存档", "版本稳定"],
    digest: "舆情公告页面结构稳定，主要变化集中在措辞微调，历史版本可供投资者核验披露内容的时间脉络。",
  },
  {
    id: 11,
    title: "某话题讨论合集页(已折叠)",
    url: "https://ssnnyw.cn/arch/10466",
    category: "社会热议",
    source: "合集页",
    lastCrawl: "2026-09-06 14:09",
    firstSeen: "2026-09-02",
    snapCount: 6,
    changePct: 31,
    status: "已删改",
    tags: ["折叠处理", "内容重组"],
    digest: "讨论合集因违规提示被折叠重组，早期聚合的原始信息与来源链接仍可从缓存中完整查看。",
  },
  {
    id: 12,
    title: "某娱乐号盘点长图配套文",
    url: "https://ssnnyw.cn/arch/10471",
    category: "综艺娱乐",
    source: "图文页",
    lastCrawl: "2026-09-06 20:31",
    firstSeen: "2026-08-27",
    snapCount: 8,
    changePct: 17,
    status: "可回溯",
    tags: ["长文", "配图留存"],
    digest: "盘点长图配套说明文经历局部删改，首发版本的完整叙述顺序与配图均在快照库中有据可查。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "吃瓜网页历史快照是怎么保存的？",
    a: "系统会在目标网页发布后按时间点自动抓取并保存只读快照，同时收录部分公开缓存版本。被删改、下线的旧版内容仍可通过对应当前与历史时间点的快照进行还原查看。",
  },
  {
    q: "我想找回一条已经删除的旧版页面，该怎么做？",
    a: "在首页搜索框输入页面链接或关键词，选择对应记录后即可查看其完整时间线。每个时间点都代表一次独立的缓存版本，点开即可浏览该时刻的原始正文。",
  },
  {
    q: "快照对比功能支持哪些方式？",
    a: "支持同一页面任意两个时间点的并排对比与差异高亮，增删改内容会用不同颜色标注，方便快速定位被改动的具体段落。",
  },
  {
    q: "存档会保留评论、配图等附加内容吗？",
    a: "只要抓取时页面可见，正文、标题、配图与评论区的公开部分都会被一并纳入快照。不可见的动态加载内容以实际抓取结果为准。",
  },
  {
    q: "使用历史快照需要付费吗？",
    a: "查看存档目录与单个页面快照的基础功能可免费使用。高频抓取监控、导出对比报告与批量追溯等进阶能力面向会员开放，具体以页面内说明为准。",
  },
  {
    q: "如何提交希望被持续监控追溯的页面？",
    a: "可通过页面底部联系方式向我们提交目标页面地址，审核通过后会被纳入自动抓取队列，后续每次变动都会生成可对比的新快照。",
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: "新媒体编辑·周女士",
    role: "行业从业者",
    tag: "追查原文",
    text: "很多热点页面删改很快，早前的完整原文根本来不及留底。现在每次变动都有时间点快照，写盘点前核对旧版方便太多了。",
  },
  {
    name: "舆情研究者·陈先生",
    role: "内容研究",
    tag: "口径核验",
    text: "我最看重的是快照对比和逐版本时间线，前后口径改没改、改了哪里一目了然，做内容追溯留痕省下了大量手工保存的工作。",
  },
  {
    name: "自由撰稿人·林女士",
    role: "内容创作者",
    tag: "素材留档",
    text: "给专题找背景资料时总担心链接失效，这里把缓存版本和旧版存档都整理在一起，引用前还能点开看原始出处，很安心。",
  },
];